module.exports = __webpack_public_path__ + "img/1_027.ac532cfa.jpg";